<template>
  <div class="ontag">
    <div
      class="ontag--content"
      v-if="printers">
      <div>
        <span class="h1">{{ $t('allPrinters') }}</span>
        <span
          v-if="isLoading"
          class="element--is-loading"></span>
      </div>
      <p>
        {{ $t('Printers.availablePrinters') }}
      </p>
      <div
        v-if="user.superUser"
        class="input-group--inline"
        style="place-self: end">
        <base-button
          class="search-button"
          :text="$t('addPrinter')"
          :button-size-small="true"
          @click="$router.push({ path: 'new-printer' })" />
      </div>

      <div class="ontag--utilitites input-group--inline">
        <div class="pagination-amount">
          <span class="first-letter">{{ $t('show') }}</span>
          <custom-select
            v-if="selectedIndexPageSize !== undefined"
            :required="false"
            @optionSelected="setPageSize"
            :selected="selectedIndexPageSize"
            :options="pageSizeOptions" />
          <span class="row-lines">{{ $t('lines') }}</span>
        </div>
        <div class="search-wrapper">
          <div class="input">
            <label
              for="searchQuery"
              class="input__label label__inline first-letter">
              {{ $t('search') }}
            </label>
            <input
              id="searchQuery"
              class="input__input input__inline search-input"
              @keyup.enter="getVariatedPrintersResults"
              v-model="searchQuery"
              type="text"
              name="searchQuery" />
          </div>
          <base-button
            class="search-button"
            :text="$t('search')"
            :button-size-small="true"
            @click="getVariatedPrintersResults"
            v-element-loader="{ loaderKey: 'printers-fetch-all' }" />
          <base-button
            class="refresh-button"
            :text="$t('Refresh')"
            :button-size-small="true"
            @click="refreshPrinters"
            v-element-loader="{ loaderKey: 'printers-refresh' }" />
        </div>
      </div>
      <div
        class="ontag--printers"
        v-if="printers && printers.rows && printers.columns">
        <list-table
          :items="printers.rows"
          :headers="printers.columns"
          @variationResults="getVariatedPrintersResults"
          :hide-in-mobile="['serialNumber', 'macAddress', 'model', 'message']">
        </list-table>
        <results-pagination
          :first-row-on-page="pagination.firstRowOnPage"
          :last-row-on-page="pagination.lastRowOnPage"
          :row-count="pagination.rowCount"
          :page-size="pagination.pageSize"
          :page-count="pagination.pageCount"
          :current-page="pagination.currentPage"
          :next-page="getNextPage()"
          :prev-page="getPrevPage()"
          store="printers"
          @currentPage="getVariatedPrintersResults" />
      </div>
    </div>
  </div>
</template>

<script>
import ListTable from '@/components/list-table/list-table';
import BaseButton from '@/components/form-elements/base-button';
import ResultsPagination from '@/components/results-pagination';
import CustomSelect from '@/components/form-elements/custom-select';
import elementLoader from '@/directives/element-loader';

export default {
  name: 'AllPrinters',
  components: {
    ListTable,
    BaseButton,
    ResultsPagination,
    CustomSelect,
  },
  directives: {
    elementLoader,
  },
  data() {
    return {
      isLoading: true,
      searchQuery: '',
      currentPage: 0,
      sort: {},
      selectedIndexPageSize: undefined,
      filters: {},
      pageSizeOptions: [
        {
          value: '10',
          displayName: '10',
        },
        {
          value: '20',
          displayName: '20',
        },
        {
          value: '40',
          displayName: '40',
        },
        {
          value: '80',
          displayName: '80',
        },
      ],
    };
  },
  methods: {
    getPrevPage() {
      return this.$store.getters['printers/previousPage'];
    },
    getNextPage() {
      return this.$store.getters['printers/nextPage'];
    },
    setPageSize(size) {
      let pageSize = {
        pageSize: size.value,
      };
      this.currentPage = 1;
      this.getVariatedPrintersResults(pageSize);
    },
    selectedPageSize(size) {
      let selectedSize = this.pageSizeOptions.findIndex(
        o => parseInt(o.value) === size
      );
      this.selectedIndexPageSize = selectedSize;
    },
    getVariatedPrintersResults(value) {
      if (value.sort) this.sort = value.sort;

      if (value.filter) {
        let checked = value.filter.options.filter(f => f.checked);
        if (checked.length > 0) {
          this.filters['Filter.' + value.filter.id] = checked.map(a => a.value);
        } else {
          delete this.filters['Filter.' + value.filter.id];
        }
      }

      if (value.pageSize) this.pageSize = value.pageSize;

      if (value.page) this.currentPage = value.page;

      const searchParams = {
        sortColumn: this.sort.id,
        sortDirection: this.sort.direction,
        search: this.searchQuery.length > 0 ? this.searchQuery : undefined,
        pageSize: this.pageSize,
        page: this.currentPage,
        ...this.filters,
      };
      this.$store.dispatch('printers/fetchAllPrinters', searchParams);
    },

    refreshPrinters() {
      this.$store.dispatch('printers/refreshPrinters').then(boolean => {
        if (boolean) {
          this.getVariatedPrintersResults({});
        }
      });
    },
  },
  computed: {
    printers() {
      return this.$store.getters['printers/printers'];
    },
    pagination() {
      return this.$store.getters['printers/pagination'];
    },
    clubId() {
      return this.$store.getters['users/clubId'];
    },
    user() {
      return this.$store.getters['user/user'];
    },
  },
  watch: {
    clubId() {
      this.setPageSize(20);
    },
  },
  created() {
    this.$store
      .dispatch('printers/fetchAllPrinters', {
        pageSize: this.pageSize,
        page: this.currentPage,
      })
      .then(() => {
        this.selectedPageSize(this.pagination.pageSize);
      })
      .finally(() => {
        this.isLoading = false;
      });
  },
};
</script>
<style lang="scss">
.element--is-loading {
  margin-left: 0.5rem;
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='50px' height='50px' viewBox='0 0 50 50'%3E%3Ccircle fill='none' stroke='%23517FD0' stroke-width='6' stroke-dasharray='45,40' cx='25' cy='25' r='15'/%3E%3CanimateTransform attributeName='transform' dur='1s' type='rotate' from='0 0 0 ' to='360 0 0' repeatCount='indefinite'/%3E%3C/svg%3E");
  background-size: 2rem 2rem;
  background-repeat: no-repeat;
  background-position: center center;
  margin-top: 20px;
}
.h1 {
  display: inline-block;
  font-size: font(h1);
  font-weight: bold;
  vertical-align: top;
  margin-top: 20px;
}
</style>
